const generateSelector = (attribute) => `[${attribute}]`;

export const GTM_ATTRIBUTE_PRODUCT_ID = 'data-product-id';
export const GTM_ATTRIBUTE_PRODUCT_COLLECTIONS = 'data-gtm-product-collections';
export const GTM_ATTRIBUTE_PRODUCT_TAGS = 'data-gtm-product-tags';
export const GTM_ATTRIBUTE_PRODUCT_RATING = 'data-gtm-product-rating';
export const GTM_ATTRIBUTE_PRODUCT_REVIEWS = 'data-gtm-product-reviews';
export const GTM_ATTRIBUTE_PRODUCT_SKU = 'data-gtm-product-sku';
export const GTM_ATTRIBUTE_PRODUCT_TITLE = 'data-gtm-product-title';
export const GTM_ATTRIBUTE_PRODUCT_PRICE = 'data-gtm-product-price';
export const GTM_ATTRIBUTE_PRODUCT_URL = 'data-gtm-product-url';
export const GTM_ATTRIBUTE_CART_PRODUCT_AVAILABILITY = 'data-gtm-cart-selector="product-detail-availability"';
export const GTM_ATTRIBUTE_PRODUCT_AVAILABILITY = 'data-gtm-product-availability';
export const GTM_ATTRIBUTE_IMAGE_URL = 'data-gtm-image-url';
export const GTM_ATTRIBUTE_PRODUCT_QUANTITY = 'data-gtm-product-quantity';
export const GTM_ATTRIBUTE_PRODUCT_INDEX = 'data-gtm-product-index';
export const GTM_ATTRIBUTE_PREDICTIVE_SEARCH_ARTICLES_COUNT = 'data-gtm-predictive-search-articles-count';
export const GTM_ATTRIBUTE_PREDICTIVE_SEARCH_COLLECTIONS_COUNT = 'data-gtm-predictive-search-collections-count';
export const GTM_ATTRIBUTE_PREDICTIVE_SEARCH_PRODUCTS_COUNT = 'data-gtm-predictive-search-products-count';
export const GTM_ATTRIBUTE_PREDICTIVE_SEARCH_CLICK = 'data-gtm-predictive-search-click';
export const GTM_ATTRIBUTE_PREDICTIVE_SEARCH_ITEM_NAME = 'data-gtm-predictive-search-item-name';
export const GTM_ATTRIBUTE_PRODUCT_CLICK = 'data-gtm-product-click';
export const GTM_ATTRIBUTE_PRODUCT_LIST_VIEW = 'data-gtm-product-list-view';
export const GTM_ATTRIBUTE_PAGE_READY = 'data-gtm-page-ready';
export const GTM_ATTRIBUTE_PRODUCT_LIST_OBSERVER = 'data-gtm-product-list-observer';

export const GTM_SELECTOR_PRODUCT_ID = generateSelector(GTM_ATTRIBUTE_PRODUCT_ID);
export const GTM_SELECTOR_CART_PRODUCT_AVAILABILITY = generateSelector(GTM_ATTRIBUTE_CART_PRODUCT_AVAILABILITY);
export const GTM_SELECTOR_PRODUCT_AVAILABILITY = generateSelector(GTM_ATTRIBUTE_PRODUCT_AVAILABILITY);
export const GTM_SELECTOR_PRODUCT_TITLE = generateSelector(GTM_ATTRIBUTE_PRODUCT_TITLE);
export const GTM_SELECTOR_PRODUCT_PRICE = generateSelector(GTM_ATTRIBUTE_PRODUCT_PRICE);
export const GTM_SELECTOR_IMAGE_URL = generateSelector(GTM_ATTRIBUTE_IMAGE_URL);
export const GTM_SELECTOR_PRODUCT_QUANTITY = generateSelector(GTM_ATTRIBUTE_PRODUCT_QUANTITY);
export const GTM_SELECTOR_PREDICTIVE_SEARCH_CLICK = generateSelector(GTM_ATTRIBUTE_PREDICTIVE_SEARCH_CLICK);
export const GTM_SELECTOR_PREDICTIVE_SEARCH_ITEM_NAME = generateSelector(GTM_ATTRIBUTE_PREDICTIVE_SEARCH_ITEM_NAME);
export const GTM_SELECTOR_PRODUCT_CLICK = generateSelector(GTM_ATTRIBUTE_PRODUCT_CLICK);
export const GTM_SELECTOR_PRODUCT_LIST_VIEW = generateSelector(GTM_ATTRIBUTE_PRODUCT_LIST_VIEW);

